
// presents images

const gostinayaPresentImg = document.querySelectorAll('#gostinaya .present span'),
    balconPresentImg = document.querySelectorAll('#balkon .present span'),
    gostinayaTriggers = document.querySelectorAll('#gostinaya .trigger'),
    kuhnyaScrollTriggers = document.querySelectorAll('#kuhnya .aside-presents li'),
    kuhnyaFoodTriggers = document.querySelectorAll('#kuhnya .trigger'),
    detskayaMakeWords = document.querySelector('#detskaya .make-words-display'),
    detskayaMakeLetter = document.querySelector('#detskaya .make-letter-display'),
    balconTriggers = document.querySelectorAll('#balkon .trigger'),
    superStartDisplay = document.querySelector('#super-start-display'),
    startDisplay = document.querySelector('#start-display');
const detskayaGameWrapper = document.querySelector('.full-height-block');
//btn
const playBtn = document.getElementById('playBtn'),
    playBtnFirst = document.getElementById('playBtnFirst'),
    btnSuperStart = document.getElementById('playBtn-superstart'),
    finishFirstGameHolder = document.getElementById('finishFirstGameHolder'),
    beginFirstGameHolder = document.getElementById('beginFirstGameHolder'),
    finishBalconGameHolder = document.getElementById('finishBalconGameHolder'),
    startBalconGameHolder = document.getElementById('beginBalconGameHolder'),
    beginDetskayaGameHolder = document.getElementById('beginDetskayaGameHolder'),
    finishDetskayaGameHolder = document.getElementById('finishDetskayaGameHolder'),
    beginKuhnyaGameHolder = document.getElementById('beginKuhnyaGameHolder'),
    finishKuhnyaGameHolder = document.getElementById('finishKuhnyaGameHolder'),
    popupRunOfTime = document.getElementById('popupRunOfTime'),
    pageWrapper = document.querySelector('.page-wrapper'),
    finalForm = document.getElementById('finalForm'),
    finalFormFormPart = document.querySelector('#finalForm .form-part'),
    finalFormThankPart = document.querySelector('#finalForm .thanks-part'),
    finishGamePopup = document.getElementById('finishGamePopup');


window.addEventListener('load', function (e) {
    const pre = document.querySelector('.preloader');
    const endPopup = document.querySelector('#game-end');
    pre.style.display = 'none';
    pageWrapper.classList.remove('overflow-all');
    // const dateNow = new Date();
    // const dateEnd = new Date('2022-01-11T00:00:00');
    // if(dateNow >= dateEnd){
    //     popupShow(endPopup);
    // }

});



let timer;
let timeMinut = null;
let gameResultSec = 0;
let gameAnaliticResultSec = 0;
const defaultTimerValue = 120;
const detskayaTimerValue = Math.floor(defaultTimerValue*.75);

btnSuperStart.addEventListener("click", function() {
    pageWrapper.classList.add('overflow-all');
    superStartDisplay.classList.add('hide-block');
    startDisplay.style.display = 'block';
    

    const mainSound = new Audio('./music/main_theme.wav');
    if (typeof mainSound.loop == 'boolean')
    {
        mainSound.loop = true;
    }
    else
    {
        mainSound.addEventListener('ended', function() {
            this.currentTime = 0;
            this.play();
        }, false);
    };
    mainSound.play();

    dataLayer.push({
        event: "start"
    });

    dataLayer.push({
        event: "click",
        category: "Landing",
        action: "btn_click",
        label: "CTA Играть",
    });

});

function getFinishCoord(elId, targets) {
    const trigTarget = targets[0].querySelector('span');
    const trigImages = [];
    let elAside = null;
    if(elId){
        elAside = document.querySelector(`.rightPresentsBlock li[data-id=${elId}]`);
    }

    for (const trigger of targets) {
        trigImages.push(trigger.querySelector('svg, img'));
    }

    return {
        elAsideLeft: getCoords(trigTarget).left,
        elAsideTop: getCoords(trigTarget).top,
        elAsideWidth: trigTarget.offsetWidth,
        elAsideHeight: trigTarget.offsetHeight,
        trigImages,
        elAside
    };

}

function timerStart(selector, time) {
    timeMinut = time ? time : defaultTimerValue;
    const inputTimer = selector.querySelector('p');
    clearInterval(timer);

    timer = setInterval(function () {
        let seconds = timeMinut%60; // Получаем секунды
        let minutes = Math.trunc(timeMinut/60%60); // Получаем минуты

        if(timeMinut > 70){
            selector.style.background = '#035929';
        }
        else if(timeMinut < 70 && timeMinut > 30){
            selector.style.background = '#ABE640';
        }
        else if(timeMinut < 30 && timeMinut > 0){
            selector.style.background = '#9D1C20';
        }
        // Условие если время закончилось то...
        if (timeMinut <= 0) {
            // Таймер удаляется
            clearInterval(timer);
            // Выводит сообщение что время закончилось
            popupRunOfTime.querySelector('.btn').dataset.last = selector.closest('.game-section-holder').id;
            popupShow(popupRunOfTime)
        } else { // Иначе
            inputTimer.innerHTML = `0${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
        }
        --timeMinut; // Уменьшаем таймер
    }, 1000)
}

function resetGame(selector, countToResult){
    const hiddenPresents = selector.querySelectorAll('.present, .shield');
    const openedPresents = selector.querySelectorAll('.trigger svg, .trigger img');
    const asidePresents = selector.querySelectorAll('.aside-presents li');
    const lettersSet = selector.querySelectorAll('.letters-done .correct:not(.preset)');
    const letterActive = selector.querySelectorAll('.letters-to-pick .active, .letters-to-pick .inactive');
    const wordsInactive = selector.querySelectorAll('.words-list .inactive, .words-list .active');
    const wordsInLetter = selector.querySelectorAll('.letter-full span[data-word]');
    const asideBlock = selector.querySelector('.rightPresentsBlock');
    const additionalDecors = selector.querySelectorAll('.add-decor-show');



    if(asideBlock){
        asideBlock.classList.remove('all-scrolls-picked');
    }



    for(let pres of asidePresents){
        const svgImg = pres.querySelector('svg use');
        if(svgImg){
            let href = svgImg.href.baseVal;
            if(!href.match(/_hidden/gm)){
                const newHref = href.replace(/_opened/gm, '');
                svgImg.setAttribute('xlink:href', newHref + '_hidden')
            }
        }
        pres.classList.remove('picked')
    }

    for(let pres of hiddenPresents){
        const svg = pres.querySelector('svg');
        const span = pres.querySelector('span');
        pres.classList.remove('picked');
        svg.style.opacity = 1;
        pres.style.opacity = 1;
        span.removeAttribute('data-triggered');
    }
    for(let pres of openedPresents){
        pres.style.opacity = 0;
    }
    for(let letter of lettersSet){
        letter.innerHTML = '';
        letter.classList.remove('correct')
    }
    for(let word of wordsInactive){
        word.classList.remove('inactive');
        word.classList.remove('active')
    }
    for(let letter of letterActive){
        letter.classList.remove('active');
        letter.classList.remove('inactive');
    }
    for(let decor of additionalDecors){
        decor.classList.remove('add-decor-show');
    }
    for(let word of wordsInLetter){
        const inserted = word.querySelector('.inserted-word');
        const initial = word.querySelector('.initial-word');
        if(inserted){
            inserted.remove();
        }
        initial.style.display = 'inline';
    }
}

function gameStart(selector, time) {
    resetGame(selector);
    const timerBlock = selector.querySelector('.game-timer');
    timerStart(timerBlock, time)
}



function flyToTarget(e, prevImg, targets, callback) {
    if(e.currentTarget.dataset.triggered) return;
    e.currentTarget.dataset.triggered = true;
    const curTarget = e.currentTarget;

    const newChild = prevImg.cloneNode(true);
    let img = prevImg.cloneNode(true),
        imgWidth = curTarget.offsetWidth,
        imgHeight = curTarget.offsetHeight,
        elLeftStart = getCoords(curTarget).left,
        elTopStart = getCoords(curTarget).top,
        elId = curTarget.id;

    prevImg.style.opacity = 0;
    document.body.append(img);
    img.style.position = 'absolute';
    img.style.zIndex = 1000;
    img.style.left = elLeftStart + 'px';
    img.style.top = elTopStart + 'px';
    img.style.width = imgWidth + 'px';
    img.style.height = imgHeight + 'px';
    img.style.transition = 'all 1s ease';
    img.classList.add('img-animate');
    img.style.transition = 'all 1.5s ease';



    const {
        elAsideLeft,
        elAsideTop,
        elAsideWidth,
        elAsideHeight,
        trigImages,
        elAside
    } = getFinishCoord(elId, targets);



    img.style.left = elAsideLeft + 'px';
    img.style.top = elAsideTop + 'px';
    img.style.opacity = 0;
    img.style.visibility = 'hidden';
    img.style.width = elAsideWidth + 'px';
    img.style.height = elAsideHeight + 'px';

    if(elId && !callback){
        const old = elAside.querySelector('svg');
        elAside.replaceChild(newChild, old);
    }

    setTimeout(() => {
        if(callback){

            callback();
        }
        for(let trigImg of trigImages){
            trigImg.style.transition = 'all 1s ease';
            trigImg.style.opacity = 1;
        }
        img.remove();

    }, 1000);
}



for (const el of gostinayaPresentImg) {
    el.addEventListener('click', function (e) {
        const targets = [...gostinayaTriggers].filter(el => e.target.id === el.dataset.id);
        const prevImg = e.target.previousElementSibling;
        flyToTarget(e, prevImg, targets);
        const countTriggered = e.target.closest('.game-section').querySelectorAll('*[data-triggered=true]').length;
        if(countTriggered === 10){
            gameResultSec += (defaultTimerValue - timeMinut);
            gameAnaliticResultSec += (defaultTimerValue - timeMinut);
            clearInterval(timer);
            setTimeout(()=> popupShow(finishFirstGameHolder), 3000)
        }
    })
}
for (const el of balconPresentImg) {
    el.addEventListener('click', function (e) {

        const parentPresent = e.target.closest('.present');
        const allParent = e.target.closest('.game-section-holder');
        const asideElems = allParent.querySelectorAll('.aside-presents li');
        const arrowPointer = allParent.querySelector('.arrow-pointer');

        if(!parentPresent.classList.contains('picked')){
            parentPresent.classList.add('picked');
            const neededAsideElem = [...asideElems].find(el => el.dataset.id === e.target.id);
            if(neededAsideElem){
                neededAsideElem.classList.add('picked');
            }

        }
        const count = e.target.closest('.bg-game').querySelectorAll('.picked').length;
        if(count === 4){

            const shields = allParent.querySelectorAll('.shield span');
            arrowPointer.classList.add('add-decor-show');

            for(let shield of shields){

                shield.addEventListener('click', function (e) {
                    const prevImg = e.target.previousElementSibling;
                    const parentShield = e.target.parentElement;
                    const targets = [...balconTriggers].filter(el => parentShield.dataset.id === el.dataset.id);
                    const presentImageToHide = [...balconPresentImg].find(el => parentShield.dataset.id === el.id);
                    arrowPointer.classList.remove('add-decor-show');
                    flyToTarget(e, prevImg, targets, function () {
                        presentImageToHide.closest('.present').style.opacity = 0;
                    });
                    const countTriggered = e.target.closest('.shields').querySelectorAll('*[data-triggered=true]').length;
                    if(countTriggered === 4){
                        gameAnaliticResultSec += (defaultTimerValue - timeMinut);
                        clearInterval(timer);
                        setTimeout(()=> popupShow(finishBalconGameHolder), 3000)
                    }
                })
            }

        }

    })
}

//crossword
const lettersToPick = document.querySelectorAll('#detskaya .letters-to-pick p');
const lettersDone = document.querySelectorAll('#detskaya .letters-done p');
const words = document.querySelectorAll('#detskaya .words-list li p');
const letterWords = document.querySelectorAll('#detskaya .letter-full span[data-word]');

function pickThing(target){
    const hasActive = target.closest('div').querySelector('.active');

    if(hasActive){
        hasActive.classList.remove('active');
    }
    target.classList.add('active')
}


lettersToPick.forEach(letter => {
    letter.addEventListener('click', function (e) {
        pickThing(e.target);
    });
});

lettersDone.forEach(letter => {
    letter.addEventListener('click', function (e) {
        const target = e.target;
        const hasActive = target.closest('.letter-holder').querySelector('.letters-to-pick .active');

        if(hasActive){
            if(hasActive.innerText.trim() === target.dataset.letter && !target.classList.contains('correct')){
                target.innerHTML = hasActive.textContent;
                target.classList.add('correct');
                hasActive.classList.add('inactive');
                hasActive.classList.remove('active');
                const correctLetters = target.closest('.letters-list').querySelectorAll('.correct').length;
                const neededLettersLength = (lettersToPick.length + lettersDone.length) / 2;

                if(correctLetters === neededLettersLength){
                    detskayaMakeWords.classList.add('hide-block');
                    detskayaMakeLetter.classList.remove('hide-block');
                    const timerBlock = document.querySelector('#detskaya .game-timer');
                    gameAnaliticResultSec += (detskayaTimerValue - timeMinut);
                    timerStart(timerBlock, detskayaTimerValue);
                    return;
                }

            }
            else{
                hasActive.classList.remove('active');
                hasActive.classList.add('error');
                setTimeout(()=>  hasActive.classList.remove('error'), 1000)
            }

        }

    });
});

words.forEach(word => {
    word.addEventListener('click', function (e) {
        pickThing(e.target);
    });
});

letterWords.forEach(letterWord => {
    letterWord.addEventListener('click', function (e) {
        const target = e.target.dataset.word ? e.target : e.target.closest('span[data-word]');
        const hasActive = target.closest('.letter-words-block').querySelector('.words-list .active');

        if(hasActive){

            if(hasActive.dataset.word === target.dataset.word){
                const span = document.createElement('span');
                span.innerHTML = hasActive.textContent.trim();
                span.classList.add('inserted-word');
                target.append(span);
                target.querySelector('.initial-word').style.display = 'none';
                target.classList.add('correct');
                hasActive.classList.add('inactive');
                hasActive.classList.remove('active');
                const correctLetters = target.closest('.letter-words-block').querySelectorAll('.inactive').length;

                if(correctLetters === letterWords.length){
                    detskayaMakeLetter.classList.add('hide-block');
                    detskayaGameWrapper.classList.add('hide-block');
                    gameAnaliticResultSec += (detskayaTimerValue - timeMinut);
                    clearInterval(timer);
                    popupShow(finishDetskayaGameHolder);
                    return;
                }

            }
            else{
                hasActive.classList.remove('active');
                hasActive.classList.add('error');
                setTimeout(()=>  hasActive.classList.remove('error'), 1000)
            }

        }

    });
});


//kitchen game
const scrolls = document.querySelectorAll('#kuhnya .present.scroll span');
const foods = document.querySelectorAll('#kuhnya .present:not(.scroll) span');

scrolls.forEach(scroll => {
    scroll.addEventListener('click', function (e) {
        const targets = [...kuhnyaScrollTriggers].filter(el => e.target.id === el.dataset.id);
        const prevImg = e.target.previousElementSibling;
        const svgImg = targets[0].querySelector('svg use');


        let href = svgImg.href.baseVal;

        flyToTarget(e, prevImg, targets, function () {
            if(!href.match(/_opened/gm)){
                const newHref = href.replace(/_hidden/gm, '_opened')
                svgImg.setAttribute('xlink:href', newHref)
            }
        });
        e.target.classList.add('scroll-found');
        const parentWrapper = e.target.closest('.game-section-holder');
        const scrollCount = parentWrapper.querySelectorAll('.scroll-found').length;

        if(scrollCount === scrolls.length){
            parentWrapper.querySelector('.rightPresentsBlock').classList.add('all-scrolls-picked');
            foods.forEach(food => {
                food.addEventListener('click', function (e) {
                    const targets = [...kuhnyaFoodTriggers].filter(el => e.target.id === el.dataset.id);
                    const prevImg = e.target.previousElementSibling;
                    const tableCatering = parentWrapper.querySelector('#kuhnya .food');
                    const asideHints = parentWrapper.querySelectorAll('.aside-presents li');

                    const neededAsideElem = [...asideHints].find(el => el.dataset.hint === e.target.id);

                    flyToTarget(e, prevImg, targets, function () {
                        tableCatering.classList.add('add-decor-show')

                        if(neededAsideElem){
                            neededAsideElem.classList.add('picked');
                        }
                    });
                    const progressCount = document.querySelectorAll('#kuhnya .present:not(.scroll) span[data-triggered]').length;

                    if(progressCount === foods.length){
                        const hatForCat = parentWrapper.querySelector('#kuhnya .cat-hat');
                        hatForCat.classList.add('add-decor-show');
                        gameResultSec += (defaultTimerValue - timeMinut);
                        gameAnaliticResultSec += (defaultTimerValue - timeMinut);
                        clearInterval(timer);
                        setTimeout(()=> popupShow(finishKuhnyaGameHolder), 3000)

                    }

                });

            })
        }
    });
});




// const lastActive = document.querySelector('#test');
// lastActive.addEventListener('click', function (e) {
//     e.preventDefault();
//     const lastActive = document.querySelector(`#kuhnya`);
//     resetGame(lastActive)
// })


  //full screen
const elem = document.documentElement;

/* View in fullscreen */
function openFullscreen() {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
    }
}

// functions
function popupShow(popup) {
    popup.classList.add('popup-show');

    pageWrapper.classList.add('popup-showing');
    pageWrapper.classList.add("overflowClass");
}
function popupHide(popup) {
    popup.classList.remove('popup-show');
    pageWrapper.classList.remove('popup-showing');
    pageWrapper.classList.remove("overflowClass");
}

//определение положения товаров в боковой строке
function getCoords(elem) { // кроме IE8-
    var box = elem.getBoundingClientRect();
    return {
        top: box.top + pageYOffset,
        left: box.left + pageXOffset
    };
}

async function analiticsSend(target, event, data) {
    await app.push(target, event, data);
}

//button actions
const bgSection = document.getElementsByClassName('bg-section'),
    gameSection = document.getElementsByClassName('game-section'),
    gameSectionHolder = document.getElementsByClassName('game-section-holder'),
    rotateScreenBox = document.getElementsByClassName('rotate-screen-box'),
    goPlayAgain = document.querySelector('#goPlayAgain'),
    finishFirstGameHolderBtns = finishFirstGameHolder.querySelectorAll('.btn'),
    finishBalconGameHolderBtn = finishBalconGameHolder.querySelector('.btn'),
    startBalconGameHolderBtn = startBalconGameHolder.querySelector('.btn'),
    beginDetskayaGameHolderBtn = beginDetskayaGameHolder.querySelector('.btn'),
    finishDetskayaGameHolderBtn = finishDetskayaGameHolder.querySelector('.btn'),
    beginKuhnyaGameHolderBtn = beginKuhnyaGameHolder.querySelector('.btn'),
    finishKuhnyaGameHolderBtn = finishKuhnyaGameHolder.querySelector('.btn'),
    finishGamePopupBtn = finishGamePopup.querySelector('.btn');


function goToKuhnya(){
    const nextGame = document.querySelector(`#kuhnya`);
    const current = document.querySelector('.current-active');
    const lastPopup = document.querySelector('.popup-show');
  
    analiticsSend('level', 'end', { name: current.id, timestamp: new Date().getTime()});

    

    current.classList.remove('current-active');
    nextGame.classList.add('current-active');
    popupHide(lastPopup);
    popupShow(beginKuhnyaGameHolder);


}

//btn Искать на главном экране
playBtn.addEventListener("click", function() {
    bgSection[0].classList.add("hide-block");
    popupShow(beginFirstGameHolder);
    gameSectionHolder[0].classList.add("current-active");
    gameSection[0].classList.add("visible-block");
    // gameSectionHolder[0].classList.add("filter-class");
    openFullscreen();
    
    window.scrollTo(0, 1);

    analiticsSend('game', 'start', {userAgent: window.navigator.userAgent || null, timestamp: new Date().getTime()})

    dataLayer.push({
        event: "click",
        category: "Landing",
        action: "btn_click",
        label: "CTA Играть 2",
    });
});

//btn Играть попап первый уровень
playBtnFirst.addEventListener("click", function() {
    gameSectionHolder[0].classList.remove("filter-class");
    popupHide(beginFirstGameHolder);
    //dataLayer.push({ event: 'playBtnFirst'});
    gameStart(gameSectionHolder[0]);
    analiticsSend('level', 'start', { name: gameSectionHolder[0].id, timestamp: new Date().getTime()});

    dataLayer.push({
        event: "click",
        category: "Level 1",
        action: "btn_click",
        label: "CTA Понятно",
    });

    dataLayer.push({
        event: "click",
        category: "Level 1",
        action: "start",
        label: "Игра началась (гостинная)",
    });

});
//btn Играть попап первый уровень
finishFirstGameHolderBtns.forEach(btn => {
    btn.addEventListener("click", function(e) {
       const nextGame = document.querySelector(`#${e.target.dataset.go}`);
       const current = document.querySelector('.current-active');
      
        analiticsSend('level', 'end', { name: current.id, timestamp: new Date().getTime()});

        dataLayer.push({
            event: "click",
            category: "Level 1",
            action: "end",
            label: "Игра закончилась (гостинная)",
        });

        current.classList.add("hide-block");
        current.classList.remove('current-active');
        nextGame.classList.add('current-active');
        popupHide(finishFirstGameHolder);

       if(e.target.dataset.go === 'balkon'){
            popupShow(startBalconGameHolder);
            dataLayer.push({
                event: "click",
                category: "Level 1",
                action: "btn_click",
                label: "CTA Пойти на балкон",
            });

            
        }
        else if(e.target.dataset.go === 'detskaya'){
            popupShow(beginDetskayaGameHolder);
            dataLayer.push({
                event: "click",
                category: "Level 1",
                action: "btn_click",
                label: "CTA Пойти в детскую",
            });
        }
        // gameSectionHolder[0].classList.remove("filter-class");
        // popupHide(beginFirstGameHolder);
        // //dataLayer.push({ event: 'playBtnFirst'});
        // gameStart(gameSectionHolder[0])
    });
});
startBalconGameHolderBtn.addEventListener("click", function(e) {

    const current = document.querySelector('#balkon');
  
    analiticsSend('level', 'start', { name: current.id, timestamp: new Date().getTime()});
    popupHide(startBalconGameHolder);
    gameStart(current)

    dataLayer.push({
        event: "click",
        category: "Level 2",
        action: "start",
        label: "Игра началась (балкон)",
    });
});
beginDetskayaGameHolderBtn.addEventListener("click", function(e) {
    const current = document.querySelector('#detskaya');
  
    analiticsSend('level', 'start', { name: current.id, timestamp: new Date().getTime()});
    detskayaGameWrapper.classList.remove('hide-block');
    popupHide(beginDetskayaGameHolder);

    gameStart(current, detskayaTimerValue)

    dataLayer.push({
        event: "click",
        category: "Level 2",
        action: "start",
        label: "Игра началась (детская)",
    });
});
finishBalconGameHolderBtn.addEventListener("click", goToKuhnya);
finishDetskayaGameHolderBtn.addEventListener("click", goToKuhnya);
beginKuhnyaGameHolderBtn.addEventListener("click", function(e) {

    dataLayer.push({
        event: "click",
        category: "Level 2",
        action: "end",
        label: "Игра закончилась",
    });

    dataLayer.push({
        event: "click",
        category: "Level 2",
        action: "btn_click",
        label: "CTA Пойти на кухню",
    });

    const current = document.querySelector('#kuhnya');
  
    analiticsSend('level', 'start', { name: current.id, timestamp: new Date().getTime()});
    popupHide(beginKuhnyaGameHolder);
    gameStart(current)

    dataLayer.push({
        event: "click",
        category: "Level 3",
        action: "start",
        label: "Игра началась (кухня)",
    });
    
});
finishKuhnyaGameHolderBtn.addEventListener("click", function(e) {
    const nextGame = document.querySelector(`#ng-block`);
    const current = document.querySelector('.current-active');

    analiticsSend('level', 'end', { name: current.id, timestamp: new Date().getTime()});

    current.classList.add("hide-block");
    current.classList.remove('current-active');
    nextGame.classList.add('current-active');
    popupHide(finishKuhnyaGameHolder);

    dataLayer.push({
        event: "click",
        category: "Level 3",
        action: "end",
        label: "Игра закончилась (кухня)",
    });

    setTimeout(()=> popupShow(finishGamePopup), 6000);

});

//btn играть еще
goPlayAgain.addEventListener("click", function() {
    gameSectionHolder[0].classList.remove("filter-class");
    popupHide(popupRunOfTime);
    //dataLayer.push({ event: 'playBtnFirst'});
    const lastActive = document.querySelector(`#${this.dataset.last}`);
    const activeLetterCombine = document.querySelector('#detskaya.current-active');

    analiticsSend('level', 'restart', { name: lastActive.id, timestamp: new Date().getTime()});
    gameStart(lastActive, activeLetterCombine ? detskayaTimerValue : null);



});
finishGamePopupBtn.addEventListener("click", function() {
    const current = document.querySelector('.current-active');
    current.classList.add("hide-block");
    current.classList.remove('current-active');
    console.log(gameResultSec);
    analiticsSend('game', 'stop', { timestamp: new Date().getTime(), gameTime: gameAnaliticResultSec});

    popupHide(finishGamePopup);
    popupShow(finalForm);

});




// валидация финальной формы
const formGetPresent = document.getElementById("formGetPresent");
const pristineten = new Pristine(formGetPresent);

formGetPresent.addEventListener('submit', function (e) {
    e.preventDefault();
    pristineten.validate();
   if(!pristineten.getErrors().length){
       //в форме нет ошибок
        //в переменной gameResultSec время за прохождение кухни + гостинной в секундах
       console.log(gameResultSec);
       submitFormLead(formGetPresent,gameResultSec)
       //вызов экрана спасибо
        //showThanks()
   }
});



function submitFormLead(formGetPresent,gameResultSec) {

    analiticsSend('form',
        'send',
        {
            name: formGetPresent[0].value,
            email: formGetPresent[1].value,
            checkbox1: formGetPresent['agreement-pers-data'].checked,
            checkbox2: formGetPresent['agreement-ads'].checked,
            totalTime: gameResultSec
        });
        
    showThanks()

    dataLayer.push({
        event: "form"
    });
           
}

//Запрет на ввод цифр
function noDigits(event) {
    if ("1234567890".indexOf(event.key) !== -1){
        event.preventDefault();
    }

}

function showThanks() {
    finalFormFormPart.classList.add('hide-block');
    finalFormThankPart.classList.remove('hide-block');
}

